module.exports = __webpack_public_path__ + "static/favicon-ea3c6acb02e1dcd3cbe23b6bc40e1776.ico";